import { headerEpic as epic } from "./epic";
import { headerReducer as reducer } from "./reducer";

export const headerEpic = epic
export const headerReducer = reducer
